/**
 * Services Export
 * Framework-agnostic service layer
 */

export * from "./base-crud";
